<template>
  <v-container>
  <v-row
      id="error-view"
      class="text-xs-center fill-height"
      column
      align="center"
      justify="center"
      >
    <v-col class="pa-3">
      <h1 :class="{'display-1': $vuetify.breakpoint.smAndDown, 'display-3': $vuetify.breakpoint.mdAndUp}" class="accent--text pb-12">
        {{$tf('Uh, oh something went wrong')}}<span v-if="errorMessage.length > 0">:</span></h1>
      <h2 :class="{'title': $vuetify.breakpoint.smAndDown, 'display-1': $vuetify.breakpoint.mdAndUp}" class="primary--text" v-html="errorMessage"></h2>
      <a :class="{'title': $vuetify.breakpoint.smAndDown, 'display-1': $vuetify.breakpoint.mdAndUp}"  v-if="showContactButton()" @click="showDialog = true">{{$tf('Support Team')}}</a>
    </v-col>
    <div>
    </div>
    <v-col cols="12" v-if="statusCode || systemError">
      <v-btn @click="showDetails = !showDetails">{{$tf('See details')}}</v-btn>
      <div class="pa-2 pt-5" v-if="showDetails&&systemError"> {{$tf('Server says')}}: {{systemError}}</div>
      <div class="pa-2" v-if="showDetails&&statusCode"> {{$tf('Status code')}}: {{statusCode}}</div>
    </v-col>
    <v-col
      cols="12" class="pa-3">
      <h3><a class="primary--text" :href="'/login?hl=' + hl + wlParam() " >{{$tf('Take me out of here')}}</a></h3>
    </v-col>
    <v-dialog
      v-model="showDialog"
      max-width="800px"
      :fullscreen="$vuetify.breakpoint.xs"
      :hide-overlay="true">
      <contact-form></contact-form>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      :color ="snackColor"
    >
      {{ $tf(snackText) }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-row>
  </v-container>

</template>

<script>
import ContactForm from './dialogs/ContactForm'
import dialogs from '../mixins/dialogs'
import useIEHelper from '@/commons/ie-helper'
import { buildWLParam } from '@/commons/whitelabel'
const { URLSearchParamsWrapper } = useIEHelper()
export default {
  name: 'error-view',
  mixins: [dialogs],
  components: { ContactForm },
  computed: {
    locale () {
      return this.$i18n.locale
    }
  },
  watch: {
    locale (v) {
      this.hl = v
      this.errorMessage = (this.errorData
        ? this.$tf(this.urlParams.get('error_message'), { 'errorData': this.errorData })
        : this.$tf(this.urlParams.get('error_message'))) || ''
    }
  },
  data () {
    return {
      errorMessage: '',
      errorData: null,
      statusCode: '',
      systemError: '',
      showDetails: false,
      urlParams: null,
      snackbar: false,
      snackText: '',
      snackColor: '',
      hl: ''
    }
  },
  beforeMount () {
    let self = this
    this.$root.$on('closeDialog', () => {
      self.showDialog = false
    })
    this.$root.$on('supportSuccess', () => {
      self.snackbar = true
      self.snackText = 'Thank you, your message has been sent'
      self.snackColor = ''
    })
    this.$root.$on('supportError', (e) => {
      self.snackbar = true
      self.snackText = e
      self.snackColor = 'red'
    })
    this.urlParams = URLSearchParamsWrapper(window.location.search)
    this.errorData = this.urlParams.get('error_data') || null
    this.errorMessage = (this.errorData
      ? this.$tf(this.urlParams.get('error_message'), { 'errorData': this.errorData })
      : this.$tf(this.urlParams.get('error_message'))) || ''
    this.statusCode = this.urlParams.get('status_code')
    this.systemError = this.$tf(this.urlParams.get('error')) || ''
    this.hl = this.urlParams.get('hl') || this.locale
  },
  mounted () {
    this.$axios.post('expire').catch(e => {
      this.$log.error(e)
    })
  },
  destroyed () {
    this.$root.$off('closeDialog')
  },
  methods: {
    showContactButton () {
      switch (this.urlParams.get('error_message')) {
        case 'Unexpected':
        case 'RestoreAccountError':
        case 'ResetPasswordError':
        case 'accessMethodError':
          return true
        default:
          return false
      }
    },
    wlParam () {
      return buildWLParam(this.$wlDomain)
    }
  }
}
</script>

<style lang="scss" scoped>
  div {
    width: 100%;
  }
  a {
    color:#1c6992 !important;
    text-decoration: #1c6992 underline;
  }
</style>
